import { allFetch } from "../Domain";

/**
 * @description 預約
 */
export const Appointment = (() => {
    /**
     * @description 預約查詢
     * @param {string} Plant 廠別流水號
     * @param {string} appointment_no 預約單號
     * @param {string} appointment_date_start 預約日期起
     * @param {string} appointment_date_end 預約日期迄
     * @param {string} appointment_status 預約狀態(未進廠、已進廠)
     * @param {string} customer_id 車主流水號
     * @param {string} car_id 車流水號
     * @param {string} license_plate 車牌號碼
     * @param {string} page 頁碼
     * @param {string} num_per_page 一頁幾筆
     */
    const AppointmentSearch = async function (obj = {
        Plant: '',
        appointment_no: '',
        appointment_date_start: '',
        appointment_date_end: '',
        appointment_status: '',
        customer_id: '',
        car_id: '',
        license_plate: '',
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('Appointment/AppointmentSearch', obj);
    }
    return {
        AppointmentSearch
    }
})();